// import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
// import { Modal } from "react-bootstrap";
import { checkTextTranslation, checkTranslation, translate } from "../../utils/useful";
// import FixedView from "../FixedView";
// import Modal from "../Modal";
// import inputComponents from "./inputComponents";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
import SidebarView from "../SidebarView";
// import FilterItems from "./FilterItems";
// import SaveFilter from './SaveFilter'
// import LoaderButton from "../LoaderButton";
import ButtonAnimated from "../buttons/ButtonAnimated";
import FilterEditorInput from "./FilterEditorInput";



class FilterEditorModal extends Component {
    state = {

        // data: {
        //     root: {
        //         id: 'root',
        //         action: translate('and'),
        //         conditions: {}
        //     }
        // },

        tempData: {},
        filters: [],
        // columns: [],


        // inputHeader: {
        //     type: 'TextInput'
        // },

        // items: [
        //     { item: '{{lang}}Name', src: '/assets/icons/name.svg' },
        //     { item: '{{lang}}Priority', src: '/assets/icons/priority.svg' },
        //     { item: '{{lang}}Flagged', src: '/assets/icons/flagged.svg' },
        //     { item: '{{lang}}Assignee', src: '/assets/icons/assignee.svg' },
        //     { item: '{{lang}}Start date', src: '/assets/icons/calendar.svg' },
        //     { item: '{{lang}}Date', src: '/assets/icons/calendar.svg' }
        // ],
        // condition: [
        //     { item: 'contains' },
        //     { item: 'does not contain' },
        //     { item: 'is' },
        //     { item: 'is not' },
        //     { item: 'is empty' },
        //     { item: 'is not empty' }
        // ],
        // slectedCell: [],
        // labela: '',
        // calca: '',
        // selectedChoose: false,
        // selectedCalc: false,
        // calc: [
        //     { title: '{{lang}}Equal', value: 'Equal' },
        //     { title: '{{lang}}Less Than', value: 'Less Than' },
        //     { title: '{{lang}}More Than', value: 'More Than' },
        //     { title: '{{lang}}Equal of less than', value: 'Equal of less than' },
        //     { title: '{{lang}}Equal of more than', value: 'Equal of more than' },
        //     { title: '{{lang}}Contains', value: 'Contains' },
        // ],
        // save: [
        //     { name: 'test', image: "/assets/icons/more-black.svg" },
        //     { name: 'number', image: "/assets/icons/more-black.svg" },
        //     { name: 'test2', image: "/assets/icons/more-black.svg" },
        //     { name: 'heiskj', image: "/assets/icons/more-black.svg" }
        // ]
    }

    componentDidMount() {
        // let current = { level: 0, groupId: 'root', parents: [] }
        if (this.props.data) {
            this.setState({ data: this.props.data })
        }
        if (this.props.filters) {
            this.setState({ filters: this.props.filters })
        }
        // else {
        //     this.setState({ current }, () => {
        //         this.doAdd('con', current)
        //     })
        // }
        // this.setState({ items: this.props.headers }, () => {
        // });
        this.init()

    }


    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers) {
            this.init()
        }
        if (prevProps.data != this.props.data) {
            this.setState({ data: this.props.data })
        }
        if (prevProps.filters != this.props.filters) {
            this.setState({ filters: this.props.filters })
        }
    }


    init() {
        this.setState({ items: this.props.headers })
        // let element
        // for (let i = 0; i < this.props.headers?.length; i++) {
        //     // element = this.props.headers[i];

        //     // this.setState({ slectedCell: element }, () => {
        //     // })
        // }
    }



    // saveAction = () => {
    //     this.saveSidebar.open()
    // }

    // selectHandler = (item) => {
    //     let items = this.state.items
    //     items.push(item)
    // }

    // doDone = () => {
    //     this.setState({ tempData: -1 }, () => {
    //         this.props.changeValue(this.props.header?.key, this.state.data, this.props.extra)
    //     })
    // }

    // openAdd = (id, parents, level) => {
    //     this.setState({ currentNode: this['add-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.fixedView.showView()
    //     })
    // }

    // openActionsView = (id, parents, level) => {
    //     this.setState({ currentNode: this['action-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.actionsView.showView()
    //     })
    // }

    // doAdd = (type, current) => {
    //     if (this.fixedView) {
    //         this.fixedView.hideView()
    //     }
    //     let id = nanoid(10)

    //     let newCondition
    //     if (type == 'con') {
    //         newCondition = { id, source: null, operator: 'Equal', target: null }
    //     } else {
    //         newCondition = { id, action: 'and' }
    //     }
    //     let data = this.state.data
    //     // let current = this.state.current
    //     current.id = id


    //     this.actionOnChild(data, current, newCondition, 'add', 0)


    //     this.setState({ data: data })
    // }

    // changeAction = (type) => {

    //     let data = this.state.data
    //     let current = this.state.current
    //     this.actionOnChild(data, current, type, 'changeOperator', 0)
    //     this.setState({ data })
    //     if (this.actionsView) {
    //         this.actionsView.hideView()
    //     }
    // }

    // removeRow = (groupId, id, parents) => {
    //     let current = { groupId, id, parents }
    //     let data = this.state.data

    //     this.actionOnChild(data, current, null, 'remove', 0)
    //     this.setState({ data: data })

    // }

    // openInput = (key, id, groupId, parents) => {
    //     let current = { groupId, id, parents, key }
    //     let data = this.state.data
    //     let value = this.actionOnChild(data, current, null, 'get', 0)

    //     let inputHeader = {
    //         type: 'SmartInput'
    //         , information: {}
    //     }

    //     if (key == 'operator') {
    //         inputHeader = {
    //             type: 'SelectInput', information: {
    //                 type: 'local', items: [
    //                     { title: '{{lang}}Equal', value: 'Equal' },
    //                     { title: '{{lang}}Less Than', value: 'Less Than' },
    //                     { title: '{{lang}}More Than', value: 'More Than' },
    //                     { title: '{{lang}}Equal or less than', value: 'Equal of less than' },
    //                     { title: '{{lang}}Equal or more than', value: 'Equal of more than' },
    //                     { title: '{{lang}}Contains', value: 'Contains' },
    //                 ]
    //             }
    //         }
    //     }

    //     this.setState({ inputHeader, currentNode: this[key + '-' + id], current: { id, groupId, parents, key, value } }, () => {
    //         this.inputView.showView()
    //     })
    // }

    // changeInputValue = (key, value) => {

    //     let current = this.state.current
    //     let data = this.state.data
    //     // let value = target.value

    //     this.actionOnChild(data, current, value, 'update', 0)
    //     current.value = value//target.value
    //     this.setState({ data, current })
    // }

    // actionOnChild(data, current, value, action, index) {

    //     if (index == current.parents.length) {

    //         if (action == 'add') {

    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             if (!data[current.groupId].conditions) {
    //                 data[current.groupId].conditions = {}
    //             }
    //             data[current.groupId].conditions[current.id] = value

    //         }

    //         if (action == 'remove') {
    //             if (current.id == null) {
    //                 delete data[current.groupId]
    //             } else {
    //                 delete data[current.groupId].conditions[current.id]
    //             }
    //         }

    //         if (action == 'changeOperator') {
    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             data[current.groupId].action = value
    //         }

    //         if (action == 'update') {
    //             data[current.groupId].conditions[current.id][current.key] = value
    //         }

    //         if (action == 'get') {
    //             return data[current.groupId].conditions[current.id][current.key]
    //         }

    //     } else if (index < current.parents.length) {
    //         let newData = data[current.parents[index]]
    //         if (newData) {
    //             return this.actionOnChild(newData.conditions, current, value, action, index + 1)
    //         }
    //     }
    // }

    // getLabel(prop, key) {
    //     let label = prop[key]
    //     let hasValue = true
    //     if (!label) {
    //         label = translate('Choose')
    //         hasValue = false
    //     }
    //     return { label, hasValue }
    // }

    // setData = (item) => {
    //     this.setState({ labela: item, selectedChoose: true, selectedCalc: true, calca: item })
    // }

    // renderGroup(data, parents, level) {
    //     if (data) {
    //         return (
    //             <div className="position-relative">
    //                 {data.action && (
    //                     <div className="flexcb" style={{ justifyContent: 'right' }}>
    //                         {level != 0 && (
    //                             <>
    //                                 <button onClick={() => this.removeRow(data.id, null, parents, level)} className=" flexcc" style={{ position: "absolute", top: 17, left: -20.5, backgroundColor: "#f6f6f6", width: 12, height: 12, borderRadius: 3 }} >
    //                                     <p className="flexcc" style={{ color: "#FF3B30" }}>&times;</p>
    //                                     {/* <img width={16} src="/assets/icons/trash.svg"/> */}
    //                                 </button>
    //                             </>
    //                         )}
    //                     </div>
    //                 )}
    //                 <div className="" style={{ backgroundColor: "transparent" }}>
    //                     {data.conditions && Object.values(data.conditions).map((prop, index) => {
    //                         if (prop) {
    //                             if (prop.action) {
    //                                 return (
    //                                     <div key={prop.id} className="px-2 pb-2 my-2 " style={{ background: '#fff', color: '#000', border: '1px solid rgba(0,0,0,0.1)', width: "100%", borderRadius: '10px' }} >
    //                                         {this.renderGroup(prop, [...parents, data.id], level + 1)}
    //                                     </div>
    //                                 )
    //                             }
    //                             else {
    //                                 return (
    //                                     <div className="w-100" key={index}>
    //                                         <FilterItems calc={this.state.calc} selectedChoose={this.state.selectedChoose} label={this.state.labela} calca={this.state.calca} setData={this.setData} getlabel={this.getLabel} changeAction={this.changeAction} items={this.state.items} renderGroup={this.renderGroup} removeRow={this.removeRow} headers={this.props.headers} prop={prop} index={index} level={level} data={data} parents={parents} openInput={this.openInput} openActionsView={this.openActionsView} />
    //                                     </div>

    //                                 )
    //                             }

    //                         }

    //                     }
    //                     )}
    //                 </div >
    //                 {data.action && (
    //                     <div className="flexc pt-2" style={{ opacity: '100%' }} >
    //                         <div ref={el => this['add-' + data.id] = el} className="w-100">
    //                             <div className="flexcb w-100">
    //                                 <button className="flexcc pld-2 prd-4 py-2 br-20" style={{ border: '1px solid #007aff' }} onClick={() => this.doAdd('con', { level: level, groupId: data.id, parents: parents })}>
    //                                     <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
    //                                     <p className="pld-1 text-smaller font-size-12" style={{ color: "#007aff" }}>{translate('Condition')}</p>
    //                                 </button>
    //                                 <button className="flexcc pld-2 prd-4 py-2 br-20" style={{ border: '1px solid #007aff' }} onClick={() => this.doAdd('group', { level: level, groupId: data.id, parents: parents })}>
    //                                     <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
    //                                     <p className="pld-1 text-smaller font-size-12" style={{ color: "#007aff" }}>{translate('Condition group')}</p>
    //                                 </button>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 )}
    //             </div>
    //         )
    //     }
    // }


    generateVisual(data) {
        if (data) {
            return this.generateGroupVisual(data.root)
        } else {
            return " "
        }
    }

    generateGroupVisual(group) {
        let text = ""
        if (group && group.conditions && typeof group.conditions == 'object') {
            // text = '('
            Object.values(group.conditions).forEach((oneInGroup, index) => {
                let onInGroupSource = ''

                this.props.headers.forEach(el => {
                    if (el.key == oneInGroup.source) {
                        onInGroupSource = el?.information?.label
                        return
                    }
                });
                if (index != 0) {
                    if (group.action == 'and') {
                        text = text + " & "
                    }
                    if (group.action == 'or') {
                        text = text + " | "
                    }
                }

                if (oneInGroup.action) {
                    text = translate('Multiple filters')
                    // text = text + this.generateGroupVisual(oneInGroup)
                } else {

                    text = text + onInGroupSource + " " + oneInGroup.operator
                    if (oneInGroup.target && oneInGroup.target != null) {
                        text = text + " " + oneInGroup.target
                    }
                    // text = text + oneInGroup.source + " " + oneInGroup.operator + " " + oneInGroup.target
                }
            });
            // text = text + ")"
        }
        // this.props.setData('filters', filters,'CollectionView')
        return text
    }


    open = () => {
        this.filterEditor.open()
    }
    applyFilter = () => {
        if (this.props.functionsHandler) {
            // this.props.setData('hasFilter', true, 'CollectionView', () => {
            // return

            this.props.functionsHandler(null, 'fetchData', this.state.data, true, () => {
                // let filters = []
                // filters.push(this.generateGroupVisual(this.state.data.root))
                // this.setState({ filters })
                this.props.setData('filters', this.state.data, 'CollectionView', () => {
                    this.props.functionsHandler(null, 'changeFilters', this.state.data, null, () => {
                        // })
                    })
                    this.filterEditor.closeSidebar()
                })
            })
        }
    }


    changeValue = (key, value, extra) => {

        this.setState({ [key]: value })
        // this.setState({ data: value })
    }

    removeRow = (group_id, id, parents) => {
        let groupId = 'root'
        let current = { groupId, id, parents }
        let data = this.state.data
        this.actionOnChild(data, current, null, 'remove', 0)
        // if(data?.root&&data?.root?.conditions&&Object.values(data?.root?.conditions).length==0){
        //     data = {}
        // }
        this.setState({ data: data }, () => {
            this.props.changeValue('data', data)
            console.log('this.state.data?.root?.conditions',Object.entries(this.state.data?.root?.conditions))
            if (Object.entries(this.state.data?.root?.conditions).length ==0) {
                this.props.setData('hasFilter', false, "CollectionView",()=>{
                    if (this.props.setHeader) {
                        this.props.setHeader("dummy", 1)
                    }
                })
            }
        })
    }

    actionOnChild(data, current, value, action, index, cb) {
        if (index == current.parents.length) {

            if (action == 'add') {

                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                if (!data[current.groupId].conditions) {
                    data[current.groupId].conditions = {}
                }
                data[current.groupId].conditions[current.id] = value

            }

            if (action == 'remove') {
                if (current.id == null) {
                    delete data[current.groupId]
                    return data
                } else {
                    delete data[current.groupId].conditions[current.id]
                    return data
                }
            }

            if (action == 'changeOperator') {
                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                data[current.groupId].action = value
            }

            if (action == 'update') {
                data[current.groupId].conditions[current.id][current.key] = value
            }

            if (action == 'get') {
                return data[current.groupId].conditions[current.id][current.key]
            }

        } else if (index < current.parents.length) {
            let newData = data[current.parents[index]]
            if (newData) {
                return this.actionOnChild(newData.conditions, current, value, action, index + 1)
            }
        }
    }


    render() {
        let hasAction = false
        let action = ''
        if (this.state.data?.root?.conditions && Object.values(this.state.data?.root?.conditions) && Object.values(this.state.data?.root?.conditions)?.length > 0) {
            Object.values(this.state.data?.root?.conditions).forEach(el => {
                if (el.action) {
                    hasAction = true
                }
            });
        }
        if (this.state.data?.root?.action && this.state.data?.root?.action == 'and') {
            action = "&"
        } else {
            action = "|"
        }
        return (
            <>
                {this.state.data && this.state.data?.root && this.state.data?.root?.conditions ? (
                    <>
                        {this.state.data?.root?.conditions && Array.isArray(Object.values(this.state.data?.root?.conditions)) && Object.values(this.state.data?.root?.conditions)?.length > 0 ? (
                            <div className="flexc px-2 py-1 sc-2 position-absolute" style={{ overflow: 'auto', bottom: '8px', zIndex: 2, width: this.props.width - 200 }}>

                                {hasAction ? (
                                    <div className={"flexc px-3 py-1 "} style={{ cursor: 'default', borderRadius: '15px', backgroundColor: this.props.colors ? '#eae9ff' : '#eee' }}>
                                        <p className="font-size-12 weight-600" style={{ color: '#222' }}>{translate('Multiple filters')}</p>
                                        <button className=" mld-3" style={{}}>
                                            <p className="flexcc" style={{ color: '#222' }}>&times;</p>
                                        </button>
                                    </div>
                                ) : (
                                    this.props.width < 600 ? (
                                        <button className={"flexc px-3 py-1 "} onClick={()=>{this.filterEditor.openSidebar()}} style={{  borderRadius: '15px', backgroundColor: this.props.colors ? '#eae9ff' : '#eee' }}>
                                            <p className="font-size-12 weight-600" style={{ color: '#222' }}>{translate('Filters')}</p>
                                        </button>
                                    ) : (
                                        Array.isArray(this.state.items)&&
                                        <div className="flexc px-3 py-1 " style={{ cursor: 'default', borderRadius: '15px', backgroundColor: this.props.colors ? '#eae9ff' : '#eee' }}>
                                            {Object.values(this.state.data?.root?.conditions).map((prop, index) => {
                                                return (
                                                    <div className="flexc">
                                                        {index != 0 && this.state.action != '' && (
                                                            <div className="px-2">
                                                                <p className="font-size-12 weight-600" style={{ color: '#222' }}>{action}</p>
                                                            </div>
                                                        )}
                                                        <p className="font-size-12 weight-600" style={{ color: '#222' }}>{this.state.items.find(el => { if (el.key == prop.source) { return el } })?.information?.label + ' ' + prop.operator + ' ' + prop.target}</p>
                                                        <button className=" mld-3" style={{}} onClick={() => { this.removeRow(this.state.data.root, prop.id, [], 0) }}>
                                                            <p className="flexcc" style={{ color: '#222' }}>&times;</p>
                                                        </button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                )}
                            </div>
                        ) : (
                            <></>
                        )}
                    </>
                ) : (
                    <></>
                )}


                <SidebarView width={this.props.width} ref={el => this.filterEditor = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '40%', lg: "35%", xl: "30%" }} >
                    <div className="w-100" style={{ maxHeight: "100%", overflow: "auto" }}>
                        <div className="flexcb p-2" style={{ position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                            <p className="text-bold font-size-18 py-1 px-2">{translate('Filter')}</p>
                            <div className="" >
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.props.isLoading ? () => { } : () => { this.applyFilter() }}
                                    title={translate('Apply')}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={this.props.colors?.textColor ?? '#fff'}
                                    isLoading={this.props.isLoading}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                    width={'100%'}
                                />
                                {/* <LoaderButton
                                    onClick={this.state.isLoading ? () => { } : () => { this.applyFilter() }}
                                    isLoading={this.state.isLoading}
                                    text={translate('Apply')}
                                    className="text-bold text-small text-center flexcc w-100 br-20 py-2 px-3  "
                                    background={this.props.background ?? '#16A34A'}
                                    width={20}
                                    height={20}
                                    color={this.props.colors?.textColor ?? '#fff'}
                                /> */}
                            </div>
                        </div>
                        {/* {(this.props.data && this.props.data != '') && (
                            <div
                                ref={el => this.input = el} className="transpanet-input " style={{ whiteSpace: 'nowrap', overflow: 'auto', }}>
                                <p className="placeholder text-start" style={{ color: '#345' }}>{checkTranslation(this.generateVisual(this.props.data))}</p>
                            </div>
                        )} */}
                        <div className="px-2 mt-2">
                            <FilterEditorInput data={this.props.data} params={this.state.items} changeValue={this.changeValue} />
                        </div>
                    </div>
                </SidebarView>

                <SidebarView ref={el => this.saveSidebar = el} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }}>
                    <div className="flexcc" style={{ height: "100%", backgroundColor: "rgb(170, 185, 207", width: "100%" }}>
                        <div className="flexcc flex-column" style={{ backgroundColor: "#fff", gap: "1.5em", height: "200px", width: "300px", boxShadow: "0px 0px 30px #10101030", borderRadius: "15px" }}>
                            {/* style={{backgroundColor:"#fff",borderRadius:"15px",boxShadow:"0px 0px 30px #10101090",height:"100vh"}} */}
                            <div className="" style={{ fontWeight: "bold" }}>
                                <p>{translate('Save your filter')}</p>
                            </div>
                            <div className="flexcb flex-column" style={{ gap: "1em" }}>
                                <div className="">
                                    <input className="p-2" type="text" placeholder={translate("Insert your filter name")} style={{ width: "250px", border: "none", backgroundColor: "#e8e8e8", borderRadius: "5px" }} />
                                </div>
                                <div className="py-2 px-3 flexcc" style={{ backgroundColor: "rgb(150, 175, 207", borderRadius: '5px', boxShadow: "0px 0px 5px #0002" }}>
                                    <button style={{ color: "#fff" }}>{translate('Add Filter')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarView>
            </>
        )
    }
}

export default FilterEditorModal;